import { useTranslation } from 'react-i18next';
import { PlaceholderStrategy } from './Placeholder';

export const Wrapper = ({
  canShowChildren = true,
  className = 'h-auto',
  displayFooter = true,
  children,
  footer,
  title,
  tooltip,
}: {
  canShowChildren?: boolean;
  className?: string;
  displayFooter?: boolean;
  children: JSX.Element | JSX.Element[];
  footer?: JSX.Element;
  title?: string | JSX.Element;
  tooltip?: JSX.Element;
}) => {
  const { t } = useTranslation();
  return (
    <div
      className={`
        ${className}
        flex
        flex-col
        border
        border-grey-30
        rounded-xl
        shadow-lg
        my-5
        dark:bg-grey-90
        dark:border-grey-70
        dark:text-white
      `}
    >
      <div
        className={`
          flex
          uppercase
          border-b
          border-grey-10
          dark:border-grey-70
          py-3
          pl-5
          font-medium
          text-sm
          items-center
          gap-1
        `}
      >
        <span className="flex w-full">{title}</span>
        {tooltip}
      </div>
      {canShowChildren ? (
        children
      ) : (
        <PlaceholderStrategy
          title={t('placeholders.compareStrategies.title')}
          subtitle={t('placeholders.compareStrategies.subtitle')}
        />
      )}
      {/* footer */}
      {displayFooter && (
        <footer
          className={`
          flex
          items-center
          mt-auto
          h-12
          border-t
          border-grey-10
          dark:border-grey-70
          px-5
        `}
        >
          <span className="text-sm italic text-grey-50">
            <span className="font-extralight mr-1">Last update:</span>1 min ago
          </span>
          {footer}
        </footer>
      )}
    </div>
  );
};
